import { Text, Pill, Product } from "components/commons";
import styles from "./purchase-order-list.module.scss";
import { dateTimeFormat, formatAmount } from "utils";
import ValidatedPopOverMenu from "./purchase-order-menu";
import { OrderStatus } from "enums";
import { prettifyOrderStatus } from "utils/pretty.utils";
import { ProductCodeEnum } from "enums";
import { prettifyProductCode } from "utils/pretty.utils";
import locale from "localization";

export const mapDataToList = ({ orders, history, showCancelModal }) => {
  const {
    orderId,
    recipient,
    stationCode,
    purchaseOrderNumber,
    salesOrderNumber,
    productType,
    status,
    remarks,
    orderItems,
    orderedAt,
  } = orders;

  return {
    orderId: (
      <>
        <Text className={styles}>{orderId ?? ""}</Text>
      </>
    ),
    purchaseOrderNo: (
      <>
        <Text className={styles.td}>{purchaseOrderNumber ?? "-"}</Text>
      </>
    ),
    salesOrderNo: (
      <>
        <Text className={styles.td}>{salesOrderNumber ?? "-"}</Text>
      </>
    ),
    orderDateAndTime: (
      <>
        <Text className={styles.td}>{dateTimeFormat(orderedAt) ?? ""}</Text>
      </>
    ),
    products: (
      <>
        {orderItems
          ?.sort((a, b) => a.orderItemId - b.orderItemId)
          .map((item) => (
            <Product
              key={item?.productCode}
              grass={item?.productCode === ProductCodeEnum.GAS91}
              salsa={item?.productCode === ProductCodeEnum.GAS95}
              deepBlue={item?.productCode === ProductCodeEnum.GAS97}
              cheddar={item?.productCode === ProductCodeEnum.DIESEL}
            >
              {prettifyProductCode(item?.productCode)}
            </Product>
          ))}
      </>
    ),
    amountInKL: (
      <>
        {orderItems?.map((item) => (
          <Text className={styles.td}>{`${formatAmount(item?.volume / 1000, "", 3, 3) ?? ""} ${
            locale.kl
          }`}</Text>
        ))}
      </>
    ),
    amountInPhp: (
      <>
        {orderItems?.map((item) => (
          <Text className={styles.td}>{item.amount <= 0 ? "-" : formatAmount(item.amount)}</Text>
        ))}
      </>
    ),
    status: (
      <Pill
        className={styles.status}
        cheddar={status === OrderStatus.ForRevision || status === OrderStatus.Pending}
        grass={status === OrderStatus.Delivered}
        cement={status === OrderStatus.Canceled}
        deepRed={status === OrderStatus.Rejected}
        sky={status === OrderStatus.Processing}
        purple={status === OrderStatus.ForDelivery}
        mainlyBlue={status === OrderStatus.ForApproval}
      >
        {prettifyOrderStatus(status)}
      </Pill>
    ),
    action: (
      <ValidatedPopOverMenu orders={orders} history={history} showCancelModal={showCancelModal} />
    ),
  };
};

export const mapFilterToRequest = (filterState) => {
  const { status, productCode, ...fs } = filterState;

  return {
    ...fs,
    status: !status.isSelectedAll ? status.value.join(",") : undefined,
    productCode: !productCode.isSelectedAll ? productCode.value.join(",") : undefined,
  };
};
